import {
	AccordionItem,
	AccordionItemContent,
	AccordionItemTrigger,
} from '@packages/chakra-v3';

import { CustomPortableText } from '@/modules/sanity-studio/components';
import type { PortableTextBlock } from 'next-sanity';

type FAQAccordionProps = {
	question: string;
	answer:   PortableTextBlock[];
	id:       string;
};

const FAQAccordion = ({
	question,
	answer,
	id,
}: FAQAccordionProps) => {
	return (
		<AccordionItem value={id}>
			<AccordionItemTrigger paddingBlock={6} paddingInline={8} textStyle={'s6'}>
				{question}
			</AccordionItemTrigger>
			<AccordionItemContent pl={4} whiteSpace={'pre-line'}>
				<CustomPortableText value={answer} whiteSpace={'pre-line'} />
			</AccordionItemContent>
		</AccordionItem>
	);
};

export default FAQAccordion;
